import useTranslation from "utils/hooks/useTranslation";

export const BallonDeChargeBlock: React.FC<{
  ballon?: Ballon;
  showPuissance?: boolean;
}> = ({ ballon, showPuissance }) => {
  const { t } = useTranslation();

  return (
    <group
      data-length="260"
      data-border="inset"
      data-space-horizontal="10"
      data-align="center"
      data-justify="center"
      data-direction="column"
    >
      <text
        //data-position="center"
        data-color="grey-color-dark"
        data-weight="400"
      >
        {ballon?.nom}
      </text>
      {showPuissance && (
        <text
          //data-position="center"
          data-color="grey-color-dark"
          data-weight="400"
        >
          {ballon?.appoints
            ?.map((a: any) => a.puissance + ` ${t("FO_UNIT_KW")}`)
            .join(" + ")}
        </text>
      )}
    </group>
  );
};
